<script setup>
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";
</script>
<template>
  <router-view></router-view>
  <Toast/>
  <ConfirmDialog group="dialog"/>
</template>
<style>
.p-menuitem-link {
  @apply text-sm p-2;
}
</style>
